enum FormsEditFunctionFields {
	FLATTEN = "flatten"
}

export default  FormsEditFunctionFields;